import React from 'react';

import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => {
    return {
        button: {
            margin: theme.spacing(1)
        }
    };
}

const basicButton = (props) => {
    const { className, classes, ...otherProps } = props;
    const classNames = [classes.button];

    if(className) {
        classNames.push(className);
    }

    return (
        <Button 
            size="small" 
            variant="contained" 
            color="primary" 
            className={classNames.join(' ')} 
            {...otherProps} 
        >
            {props.children}
        </Button>
    );
}

export default withStyles(styles)(basicButton);